import React, { useState, useEffect } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';

import GoogleMapContainer from '../GoogleMapContainer';
import EventEmitter from '../../../lib/eventEmitter';
import { groupBy } from '../../../lib/helpers';
import { selectFeedMarker } from '../../../actions/feed';

export interface Props {
  allowDrawing?: boolean;
  favorites?: any[];
  feed: any[];
  initialMapLoad?: boolean;
  isMarkerShown: boolean;
  latitude?: number;
  loadMapFeed?: Function;
  longitude?: number;
  marker?: any[];
  placeBoundaries?: any;
  toggleCityBoundary?: Function;
  router: any;
  zoom?: number;
  markerClicked: string;
  selectedListing: any;
  dispatch: any;
}
export interface State {
  isOverlayShown: boolean;
  markerFocused: string;
  overlayLat: number;
  overlayListing: any;
  overlayLng: number;
  overlayText: string;
  zoom: number;
}

export const ListingMap: React.FC<Props> = props => {
  const [state, setState] = useState<any>({
    isOverlayShown: false,
    markerFocused: '',
    overlayLat: 42.3601,
    overlayListing: '',
    overlayLng: -71.0589,
    overlayText: '',
    zoom: props.zoom || 15,
  });

  const handleMarkerEnter = (
    text: string,
    lat: number,
    lng: number,
    listing: any,
    key: string,
    id: string,
  ) => {
    if (key === 'Property Location') {
      setState({
        isOverlayShown: true,
        overlayLat: lat,
        overlayListing: undefined,
        overlayLng: lng,
        overlayText: text,
      });
    } else {
      setState({
        isOverlayShown: true,
        markerFocused: id,
        overlayLat: lat,
        overlayListing: listing,
        overlayLng: lng,
        overlayText: text,
        zoom: props.zoom || 15,
      });
    }
  };

  useEffect(() => {
    if (props.selectedListing) {
      handleMarkerEnter(
        props.selectedListing.name,
        props.selectedListing.latitude,
        props.selectedListing.longitude,
        props.selectedListing,
        props.selectedListing.key,
        props.selectedListing.id,
      );
    } else {
      if (state.markerFocused) {
        handleMarkerLeave();
      }
    }
  }, [props.markerClicked, props.selectedListing]);

  const focusMarker = (id: string) => {
    setState({
      markerFocused: id,
    });
  };

  const handleZoom = (zoom: number) => {
    setState({
      zoom,
    });
  };

  const onMarkerClick = (listing: any, hideOverlay: boolean = false) => {
    if (hideOverlay) {
      props.dispatch(selectFeedMarker(listing.id, ''));
    } else {
      props.dispatch(selectFeedMarker(listing.id, listing));
    }
  };

  const onMarkerReset = () => {
    props.dispatch(selectFeedMarker('', ''));
    handleMarkerLeave();
    EventEmitter.emit('onMouseLeaveMarker');
  };

  const handleMarkerLeave = () => {
    setState({
      isOverlayShown: false,
      markerFocused: '',
      overlayListing: '',
      overlayText: '',
    });
  };

  const { groupedResults } = groupBy(props.feed, 'latitude', 'longitude');

  return (
    <GoogleMapContainer
      allowDrawing={props.allowDrawing}
      center={{
        lat: props.latitude || 42.3601,
        lng: props.longitude || -71.0589,
      }}
      defaultMarker={props.marker}
      zoom={state.zoom}
      favorites={props.favorites}
      feed={props.feed}
      focusMarker={focusMarker}
      groupedResults={groupedResults}
      initialMapLoad={props.initialMapLoad}
      isOverlayShown={state.isOverlayShown}
      loadMapFeed={props.loadMapFeed}
      markerClicked={props.markerClicked}
      markerFocused={state.markerFocused}
      markerReset={onMarkerReset}
      onMarkerClick={onMarkerClick}
      onMarkerEnter={handleMarkerEnter}
      onMarkerLeave={handleMarkerLeave}
      overlayListing={state.overlayListing}
      overlayText={state.overlayText}
      placeBoundaries={props.placeBoundaries}
      router={props.router}
      selectedListing={props.selectedListing}
      toggleCityBoundary={props.toggleCityBoundary}
    />
  );
};

const mapStateToProps = (state: any) => ({
  markerClicked: state.feed.markerClicked,
  selectedListing: state.feed.selectedListing,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ListingMap),
);
